import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NameAndWidth } from '../../models/patient-model';
import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-table',
  standalone: false,
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent implements OnChanges {
  @Input() tableTitle: string = '';
  @Input() columns: NameAndWidth[] = [];
  @Input() buttons_firstSet: string[] = [];
  @Input() buttons_secondSet: string[] = [];
  @Input() hasModifyButtonBeenClicked: boolean = false;
  @Input() tableData: any[] = [];

  @Output() buttonEvent = new EventEmitter<ButtonClickData>();
  @Output() titleSelected = new EventEmitter<any>();

  buttons: string[] = [];

  constructor(public labelService: LabelService) {}

  buttonClicked(button: string, itemRow: any) {
    const eventData: ButtonClickData = {
      button: button,
      rowData: itemRow,
    };
    this.buttonEvent.emit(eventData);
  }

  columnClicked(itemRow: any) {
    this.titleSelected.emit(itemRow);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hasModifyButtonBeenClicked']) {
      this.updateButtons();
    }
  }

  getButtonActionDescription(button: string): string {
    switch (button) {
      case 'edit':
        return 'Modifica questo elemento';
      case 'delete':
        return 'Elimina questo elemento';
      case 'visibility':
        return 'Visualizza il file';
      case 'download':
        return 'Scarica il file';
      case 'send':
        return 'Invia';
      case 'content_copy':
        return 'Duplica questo elemento';
      default:
        return '';
    }
  }

  private updateButtons() {
    this.buttons = this.hasModifyButtonBeenClicked
      ? this.buttons_secondSet
      : this.buttons_firstSet;
  }
}

interface ButtonClickData {
  button: string;
  rowData: any;
}
